import React, { Component } from 'react';
import { Modal, Button } from 'semantic-ui-react';
import Login from '../Login';
import Register from '../Register';

export default class LoginRegisterModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loginModelOpen: false,
            registerModalOpen: false
        };
    }

    handleLoginModalOpen = () => {
        this.setState({ loginModelOpen: true });
    }

    handleRegisterModalOpen = () => {
        this.setState({ registerModalOpen: true });
    }

    handleLoginModalClose = () => {
        this.setState({ loginModelOpen: false });
    }

    handleRegisterModalClose = () => {
        this.setState({ registerModalOpen: false });
    }

    render() {
        const { loginModelOpen, registerModalOpen } = this.state;

        return (
            <Modal size='tiny' open={this.props.open} onClose={this.props.onClose} closeIcon>
                <Modal.Header>Authorization</Modal.Header>
                <Modal.Content>
                    <p>You must log in or register before saving or submitting an application.</p>
                    <p>Your current progress will not be lost once you log in.</p>
                </Modal.Content>
                <Modal.Actions>
                    <Login modalOpen={loginModelOpen} handleClose={this.handleLoginModalClose} />
                    <Button onClick={this.handleLoginModalOpen} basic color='green' content='Log In' />
                    <Register modalOpen={registerModalOpen} handleClose={this.handleRegisterModalClose} />
                    <Button onClick={this.handleRegisterModalOpen} basic color='green' content='Register' />
                    <Button onClick={this.props.onClose} basic content='Close' />
                </Modal.Actions>
            </Modal>
        );
    }
}